"use strict";

exports.__esModule = true;
exports.version = void 0;
// generated by genversion
var version = '5.0.4';
exports.version = version;